export const selectDesignations = (state) =>
  state.companyDesignation?.designations || [];

export const selectDesignationLoading = (state) =>
  state.companyDesignation?.loading || false;

export const selectDesignationError = (state) =>
  state.companyDesignation?.error || null;

export const selectSelectedDesignation = (state) =>
  state.companyDesignation?.selectedDesignation || null;
